import React from "react";
import { useLocation } from "react-router-dom";

import { Text } from "@performyard/py-components";

import Breadcrumbs from "../../../../components/Breadcrumbs";

import { config } from "../config";

type MeetingDetailsBreadcrumbsProps = {
	workspaceName: string;
	workspaceId: string;
	meetingName: string;
	isAdmin?: boolean;
};

/**
 * Breadcrumb navigation for the meeting details page.
 * Shows: Meetings/Meeting Workspaces > Workspace Name > Meeting Name
 */
const MeetingDetailsBreadcrumbs = ({
	workspaceName,
	workspaceId,
	meetingName,
	isAdmin = false,
}: MeetingDetailsBreadcrumbsProps): React.ReactElement => {
	const location = useLocation();
	const previousSearchParams = new URLSearchParams(location.search).get("from") || "";

	const workspaceUrl = previousSearchParams
		? `/meeting-workspaces/${workspaceId}${previousSearchParams}`
		: `/meeting-workspaces/${workspaceId}`;

	const pages = [
		{
			pageID: "meetingWorkspaces",
			label: isAdmin ? "Meetings" : "Meeting Workspaces",
			url: isAdmin ? "/company/meetings" : "/meeting-workspaces",
		},
		{
			pageID: "workspaceDetails",
			label: (
				<div className="py-text-truncate" style={{ maxWidth: config.layout.breadcrumbMaxWidth }}>
					<Text size="paragraph-2" weight="regular" overrideElement="span" wrap={false}>
						{workspaceName}
					</Text>
				</div>
			),
			url: workspaceUrl,
		},
		{
			pageID: "meetingDetails",
			label: (
				<div className="py-text-truncate" style={{ maxWidth: config.layout.breadcrumbMaxWidth }}>
					<Text size="paragraph-2" weight="regular" overrideElement="span" wrap={false}>
						{meetingName}
					</Text>
				</div>
			),
			url: "",
		},
	];

	return <Breadcrumbs pages={pages} />;
};

export default MeetingDetailsBreadcrumbs;
